import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output
} from "@angular/core";
import {OverlayRef} from "@angular/cdk/overlay";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";
import {AutoDispatchTimeRange} from "../../../models/visit-schedule-dispatch-settings.model";

interface VisitPlanAutoDispatchDialogData {
  enabled: boolean;
  selectedRange: AutoDispatchTimeRange;
  timeRanges: AutoDispatchTimeRange[];
  saving: boolean;
}

export interface VisitPlanAutoDispatchDialogResult {
  enabled: boolean;
  range: AutoDispatchTimeRange;
}

require('./visit-plan-auto-dispatch-dialog.scss');
@Component({
  standalone: false,
  selector: 'app-visit-plan-auto-dispatch-dialog',
  templateUrl: './visit-plan-auto-dispatch-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitPlanAutoDispatchDialogComponent implements OnInit {

  @Output() onClose = new EventEmitter<VisitPlanAutoDispatchDialogResult | undefined>();

  public enabled: boolean;
  public selectedRange: AutoDispatchTimeRange;
  public timeRanges: AutoDispatchTimeRange[];
  public saving: boolean;

  private initialEnabled: boolean;
  private initialRangeFrom: string;
  private initialRangeTo: string;

  constructor(
    @Inject(PANEL_DATA) public data: VisitPlanAutoDispatchDialogData,
    @Inject(OverlayRef) private overlayRef: OverlayRef
  ) {
  }

  ngOnInit(): void {
    this.enabled = !!this.data.enabled;
    this.selectedRange = this.data.selectedRange;
    this.timeRanges = this.data.timeRanges || [];
    this.saving = !!this.data.saving;

    this.initialEnabled = this.enabled;
    this.initialRangeFrom = this.selectedRange?.from;
    this.initialRangeTo = this.selectedRange?.to;
  }

  onEnabledToggle(checked: boolean): void {
    this.enabled = checked;
  }

  onRangeChange(range: AutoDispatchTimeRange): void {
    this.selectedRange = range;
  }

  isDirty(): boolean {
    if (this.enabled !== this.initialEnabled) {
      return true;
    }
    return this.selectedRange?.from !== this.initialRangeFrom
      || this.selectedRange?.to !== this.initialRangeTo;
  }

  onSubmit(): void {
    if (!this.selectedRange || this.saving || !this.isDirty()) {
      return;
    }
    this.onClose.emit({
      enabled: this.enabled,
      range: this.selectedRange
    });
  }

  onCancel(): void {
    this.onClose.emit(undefined);
  }
}
